module.exports = __webpack_public_path__ + "img/17.5f86cccb.png";